export default __webpack_public_path__ + "static/ft2019-75084c6082673c8f598c48bca7b462c5.png";